<glxy-page [isLoading]="isLoading()">
  <glxy-page-toolbar>
    <glxy-page-title>{{ 'INBOX.SETTINGS.WEBCHAT_CONFIGURATION' | translate }}</glxy-page-title>
    <glxy-page-actions>
      <mat-slide-toggle [checked]="enabled()" [disabled]="true">
        {{ (enabled() ? 'INBOX.WEBCHAT.SETTINGS.ENABLED' : 'INBOX.WEBCHAT.SETTINGS.DISABLED') | translate }}
      </mat-slide-toggle>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper widthPreset="narrow" *ngIf="!!error()">
    <ng-container
      [ngTemplateOutlet]="errorTemplate"
      [ngTemplateOutletContext]="{ errorMessage: error() }"
    ></ng-container>
  </glxy-page-wrapper>

  <glxy-page-wrapper widthPreset="narrow" *ngIf="webchat$ | async as webchat">
    <div class="content">
      <inbox-web-chat-instructions
        [widgetId]="webchat?.widgetId || ''"
        [widgetNamespace]="webchat?.namespace || ''"
      ></inbox-web-chat-instructions>
    </div>

    <inbox-sticky-footer
      (submitClick)="done()"
      cancelLink="./edit"
      [submitOverride]="'INBOX.DONE' | translate"
      [cancelOverride]="'INBOX.EDIT' | translate"
    ></inbox-sticky-footer>
  </glxy-page-wrapper>
</glxy-page>

<ng-template #errorTemplate let-errorMessage="errorMessage">
  <glxy-alert type="error">
    <strong>{{ 'INBOX.WEBCHAT.SETTINGS.SOMETHING_WENT_WRONG' | translate }}</strong>
    <glxy-alert-extended>
      {{ errorMessage }}
    </glxy-alert-extended>
  </glxy-alert>
</ng-template>
